import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../services/env-config.service';
import { CommonModule } from '@angular/common';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { ReactiveFormsModule } from '@angular/forms';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [
      ReactiveFormsModule,
         NzGridModule,
         TranslateModule,
         NzFlexModule,
         NzTypographyModule,
         NzButtonModule,
         NzDividerModule,
         NzIconModule,
         NzImageModule,
         NzFormModule,
         NzInputModule,
         NzSpaceModule,
         NzModalModule,
         CommonModule
    ],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements OnInit {
maintenanceMessage = '';
private destroy$ = new Subject<void>();
private config: any;

constructor(
   private configService: ConfigService,
   private translateService: TranslateService,
   private cdr: ChangeDetectorRef
 ) {}

  ngOnInit(): void {
    this.configService.getConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        this.config = config;
        this.updateMessage(this.translateService.currentLang);
      });
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        this.updateMessage(event.lang);
      });
  }

  updateMessage(lang: string): void {
    this.maintenanceMessage =
      this.config?.maintenanceMessage?.[lang]
      ?? this.config?.maintenanceMessage?.it
      ?? '';
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}